export default __webpack_public_path__ + "static/media/62.1cb021ed.jpg";